const API = (function() {
	const storage = {};
	const simpleGetRequest = (url, props = {}) => {
		const {cache = true} = props;
		if(cache && storage[url]) {
			return Promise.resolve(storage[url])
		};
		return fetch(url).then(res => {
			storage[url] = res.json();
			return storage[url];
		})
	}
	return {
		getBundles: () => simpleGetRequest('./output/data/bundles.json'),
		getOptionsObject: () => simpleGetRequest('./output/data/options.json'),
		getDefaultSelections: source => simpleGetRequest(`./output/data/selected-${source}.json`),
		getProductDetails: id => simpleGetRequest(`./output/data/details-${id}.json`),
		getHardCodeOptionsObject: () => simpleGetRequest('./hardcode/data/options.json'),
	}
})();

export default API;